module.exports = __webpack_public_path__ + "img/monochrome_photos.ea15f015.svg";